export const TOAST_MESSAGE = {
  '': {
    success: '성공하였습니다',
    error: '실패하였습니다',
    description: '',
  },
  email: {
    success: '메일 주소가 복사되었습니다',
    error: '메일 주소 복사에 실패하였습니다',
    description: '잠시 후 다시 시도해주세요',
  },
  url: {
    success: '약속방 링크가 복사되었습니다',
    error: '약속방 링크 복사에 실패하였습니다',
    description: '잠시 후 다시 시도해주세요',
  },
  code: {
    success: '입장 코드가 복사되었습니다',
    error: '입장 코드 복사에 실패하였습니다',
    description: '잠시 후 다시 시도해주세요',
  },
  timeBlock: {
    success: '',
    error: '지난 시간은 선택이 불가능합니다',
    description: '',
  },
  schedule: {
    success: '일정 수정이 완료되었습니다',
    error: '일정 수정에 실패하였습니다',
    description: '잠시 후 다시 시도해주세요',
  },
};
